import { getChildrensFromHTML } from "./get-childrens-from-html";
import { getSelectionHTMLUntil } from "./get-html-until";
import { getSelectedHtml } from "./get-selected-html";
import { restoreSelectionFromNodeList } from "./restore-selection";
import { splitNode } from "./split-node";

export function replaceSelectionWithoutFormat(
  document,
  selection,
  range,
  formatParent,
  element,
  restoreSelection = true,
) {
  var selHTML = getSelectionHTMLUntil(document, formatParent[0]);
  let ranges = splitNode(document, selection, formatParent[0]);

  // Previous Selection Format
  var previousFormatTag = document.createElement(element);
  let prevFragment = ranges.previous.cloneContents();
  previousFormatTag.appendChild(prevFragment);

  // Current Selection Format
  var currentFormatTag = document.createElement(element);
  let currentFormat = ranges.current.cloneContents();
  currentFormatTag.appendChild(currentFormat);

  // Next Selection Format
  var nextFormatTag = document.createElement(element);
  let nextFragment = ranges.next.cloneContents();
  nextFormatTag.appendChild(nextFragment);

  // Selection Unformat
  var unformattedFragment = document.createDocumentFragment();
  var unformattedChildrens = getChildrensFromHTML(selHTML);
  unformattedChildrens.forEach((child) => {
    unformattedFragment.appendChild(child);
  });

  var nodesFragment = document.createDocumentFragment();
  nodesFragment.appendChild(previousFormatTag);
  nodesFragment.appendChild(unformattedFragment);
  nodesFragment.appendChild(nextFormatTag);

  formatParent[0].parentNode.replaceChild(nodesFragment, formatParent[0]);

  // Restore Selection
  var nodeAfterPrevFormatTag = previousFormatTag.nextSibling;
  var nodeBeforeNextFormatTag = nextFormatTag.previousSibling;

  if (restoreSelection) {
    restoreSelectionFromNodeList(document, selection, [
      nodeAfterPrevFormatTag,
      nodeBeforeNextFormatTag,
    ]);
  }

  return {
    firstChild: nodeAfterPrevFormatTag,
    lastChild: nodeBeforeNextFormatTag,
  };
}
